export const LEVEL_ONE_ORDER_OPTIONS = Object.freeze([1, 2, 3, 4]);

export function isLevelOneBanner(value) {
    return Number(value) === 1;
}

export async function checkBannerOrderAvailability({ tipo_banner, orden_banner, id }) {
    const payload = {
        tipo_banner,
        orden_banner
    };
    if (id) {
        payload.id = id;
        payload.ID = id;
    }
    const response = await fetch('/banner-order/check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    });
    let data = null;
    try {
        data = await response.json();
    } catch (error) {
        data = null;
    }
    if (!response.ok && response.status !== 409) {
        const message = extractErrorMessage(data) || 'No se pudo validar el orden del banner';
        const err = new Error(message);
        err.payload = data;
        err.status = response.status;
        throw err;
    }
    return {
        ...parseOrderCheckResponse({ status: response.status, body: data }),
        raw: data
    };
}

function extractErrorMessage(body) {
    if (!body) return '';
    if (typeof body.message === 'string') return body.message;
    if (typeof body.error === 'string') return body.error;
    return '';
}

function parseOrderCheckResponse({ status, body }) {
    const occupant = extractOccupant(body);
    const occupantName = extractOccupantName({ occupant, body });
    const normalizedStatus = typeof body?.status === 'string'
        ? body.status.trim().toUpperCase()
        : '';
    const normalizedMessage = typeof body?.message === 'string'
        ? body.message.trim().toUpperCase()
        : '';
    const hasConflict = status === 409
        || Boolean(body?.conflict || body?.hasConflict || body?.occupied || body?.slot?.occupied)
        || normalizedStatus === 'CONFLICT'
        || normalizedStatus === 'ORDER_CONFLICT'
        || normalizedMessage === 'ORDER_CONFLICT';
    return {
        hasConflict,
        occupant,
        occupantName: hasConflict ? (occupantName || 'otro banner') : null
    };
}

function extractOccupant(body) {
    if (!body || typeof body !== 'object') return null;
    if (body.occupant) return body.occupant;
    if (body.current) return body.current;
    if (body.banner) return body.banner;
    if (body.slot && body.slot.occupant) return body.slot.occupant;
    if (body.slot && body.slot.current) return body.slot.current;
    return null;
}

function extractOccupantName({ occupant, body }) {
    if (occupant && typeof occupant === 'object') {
        return occupant.nombre
            || occupant.name
            || occupant.title
            || occupant.banner_name
            || occupant.bannerName
            || occupant.NOMBRE_BANNER
            || occupant.NOMBRE
            || null;
    }
    if (body && typeof body === 'object') {
        return body.banner_name
            || body.bannerName
            || body.nombre
            || null;
    }
    return null;
}
